import { MarketPlace } from "@/api/types/main/schemas";
import { OzoneIcon } from "@/assets/ozone.icon";
import { WildberriesIcon } from "@/assets/wildberries.icon";
import { type ClassValue, clsx } from "clsx";
import { useRef } from "react";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNumber(value: number): string {
  if (typeof value !== "number") return "0";

  const roundedValue = Number.isInteger(value) ? value : Number(value.toFixed(2));

  return new Intl.NumberFormat("ru-RU", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(roundedValue);
}

export function formatSegmentLabel(from: number, to: number): string {
  if (to >= 999999) return `${formatCompactNumber(from)}+ ₽`;
  return `${formatCompactNumber(from)}–${formatCompactNumber(to)} ₽`;
}

export function formatCompactNumber(value: number): string {
  if (typeof value !== "number" || !Number.isFinite(value)) return "0";
  return new Intl.NumberFormat("ru-RU", {
    notation: "compact",
    maximumFractionDigits: 1,
    compactDisplay: "short",
  }).format(value);
}
export const getMarketplaceIcons = (marketplace: MarketPlace) => {
  return marketplace === "OZON" ? <OzoneIcon /> : <WildberriesIcon />;
};

export const useRenderCounter = (componentName: string) => {
  const renderCount = useRef(0);

  renderCount.current += 1;

  if (renderCount.current % 10 === 0) {
    console.log(`${componentName} rendered: ${renderCount.current} times`);
  }

  return renderCount.current;
};
